var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#F9FAFA","key":0}),React.createElement("path",{"d":"M15.6 8.40002L8.40002 15.6","stroke":"#50555E","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M8.40002 8.40002L15.6 15.6","stroke":"#50555E","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

CloseIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
